import { useEffect, useState } from "react";
import { EditTwoTone } from "@ant-design/icons";
import {
  Button,
  Col,
  Drawer,
  Form,
  Input,
  Modal,
  Row,
  Select,
  Space,
  Spin,
  message,
  notification,
} from "antd";
import {
  callFetchPermissionById,
  callUpdatePermission,
} from "../../../../config/api";
import { IPermission } from "../../../../types/backend";
import { ALL_METHOD, ALL_MODULES } from "../../../../utils/constants/permissions";


const ModalPermission = ({
  id,
  handleFetchPermission,
}: {
  id: string;
  handleFetchPermission: any;
}): JSX.Element => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false)
  const [form] = Form.useForm();
  const [detailPermission, setDetailPermission] = useState();
  const showModal = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const fetchPermissionById = async () => {
    const result: any = await callFetchPermissionById(id);
    setDetailPermission(result.data);
  };
  useEffect(() => {
    fetchPermissionById();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const onFinish = async (values: IPermission) => {
    setLoading(true)
    const res: any = await callUpdatePermission(values, id);
    if (res && res.statusCode === 200) {
      handleFetchPermission();
      message.success("update success!");
      setOpen(false);
    } else {
      notification.error({
        message: "Đã có lỗi xảy ra",
        description: res.message,
      });
    }
    setLoading(false)
  };

  useEffect(() => {
    form.setFieldsValue(detailPermission);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [detailPermission]);

  return (
    <Spin spinning={loading}>
      <Button
        style={{ border: "1px solid #f57800" }}
        type="primary"
        ghost
        onClick={showModal}>
        <EditTwoTone twoToneColor="#f57800" style={{ cursor: "pointer" }} />
      </Button>
      <Modal
        title="Chỉnh sửa phân quyền"
        open={open}
        onOk={() => {
          form.submit();
        }}
        okText="Lưu"
        cancelText="Hủy"
        maskClosable={false}
        width={840}
        onCancel={onClose}
      >
        <Form
          layout="vertical"
          form={form}
          onFinish={onFinish}
          hideRequiredMark>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="name"
                label="Name"
                rules={[{ required: true, message: "Please enter name" }]}>
                <Input
                  placeholder="Please enter name"
                  style={{ height: "32px" }}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="apiPath"
                label="API Path"
                rules={[{ required: true, message: "Please enter apiPath" }]}>
                <Input
                  placeholder="Please enter apiPath"
                  style={{ height: "32px" }}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="method"
                label="Method"
                rules={[{ required: true, message: "Please enter method" }]}>
                <Select defaultValue="" options={ALL_METHOD} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="module"
                label="Thuộc Module"
                rules={[{ required: true, message: "Please enter module" }]}>
                <Select defaultValue="" options={ALL_MODULES} />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </Spin>
  );
};

export default ModalPermission;
